import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const names = new Map<string, string>();

/** A trip's name for labels like the top bar's way back; null until known. */
export function useTripName(tripId: string | undefined): string | null {
  const [name, setName] = useState<string | null>(() => (tripId ? names.get(tripId) ?? null : null));
  useEffect(() => {
    if (!tripId) return;
    setName(names.get(tripId) ?? null);
    let cancelled = false;
    getDoc(doc(db, "trips", tripId))
      .then((snap) => {
        const n = snap.exists() ? (snap.data().name as string | undefined) : undefined;
        if (n) names.set(tripId, n);
        if (!cancelled && n) setName(n);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [tripId]);
  return name;
}
